<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-toltip-aba-cultura"
                    />
                </div>
                <div class="column is-3" v-if="permissao.create && !culturaProdutoIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularCultura"
                    >
                        {{ $t('vincular-cultura') }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissao.create && !culturaIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'agro-cultura-new',
                                query: {
                                    tela: 'produto-cultura',
                                    id: $route.params.id,
                                    dadoscadastrais: 10,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-cultura') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutocultura"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label ? f.label : f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !culturaIntegracao"
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <CulturaModal :idProduto="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
            <!-- MODAL DE CADASTRO UNIDADE MEDIDA -->
            <b-modal :active.sync="showModalCadastro" @close="fecharModal">
                <div>
                    <CulturaCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastradaCultura"
                        :culturaProdutoIntegracao="culturaProdutoIntegracao"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTipoCulturaProdutoService from '@/services/agro/cultura/AssTipoCulturaProdutoService.js';
import CulturaModal from '@/components/vendas/produto/modal/CulturaModal.vue';
import CulturaCadastroModal from '../../modal/CulturaCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        CulturaModal,
        CulturaCadastroModal,
    },
    data() {
        return {
            culturaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOCULTURA'),
            culturaProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTIPOCULTURAPRODUTO'
            ),
            assprodutocultura: [],
            fields: [
                {
                    key: 'idasstipoculturaproduto',
                    label: 'codigo',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'tipocultura', label: 'tipo-cultura', sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],

            service: new AssTipoCulturaProdutoService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            showModalCadastro: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-cultura'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-cultura' },
            });

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        cadastradaCultura() {
            this.showModalCadastro = false;
            this.isUpdate = false;
            this.showModalAssociacao = true;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .listCulturasByProduct(
                    this.$route.params.id,
                    this.column,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.order,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutocultura = value;
                    this.isEmpty = this.assprodutocultura.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    situacao: m.situacao,
                    replicapda: m.replicapda,
                    tipocultura: m.tipocultura.descricao,
                    idasstipoculturaproduto: m.idasstipoculturaproduto,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['tipocultura'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-n'
                    : 'msg-erro-ao-desativar-n', 
                { n: this.$t('tipo-cultura') }
            );

            let tempAssProdutoCultura = {
                idasstipoculturaproduto: this.delete.idasstipoculturaproduto,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAssProdutoCultura)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('tipo-cultura') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularCultura() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.showModalCadastro = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
